import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { HelpFulSection, ThankYouFeedback, YesNoThumbs } from './styled';
import { fireClickedCTAEvent } from '../../../Utils/useFirebase';

export default function IsthisHelpfulSection(props) {
  const [ShowValuableFeedback, setShowValuableFeedback] = useState(false);
  // const [showPopup, setShowPopup] = useState(false);
  const router = useRouter();
  const HelpulHandler = (value) => {
    fireClickedCTAEvent('is this helpfull ', value, 'article_detail_page');
    setShowValuableFeedback(true);
  };
  // const getAppHandler = () => {
  //     fireClickedCTAEvent(
  //         "is this helpfull ",
  //         "get mylo app",
  //         "article_detail_page",
  //     );
  //     // if (getDeviceType() == "desktop") {
  //     //     // setShowPopup(true);
  //     //     // router.push(`${getPublicUrl()}/store` + window.location.search);
  //     // } else {
  //     window.location.href = `${getBranchLink()}`;
  //     // }
  // };

  return (
    <HelpFulSection>
      {ShowValuableFeedback ? (
        <ThankYouFeedback>
          <img
            src="/images/mylo_happiness_logo.svg"
            alt="mylo_happiness_logo"
          />
          <span>Thank you for your Feedback!</span>
        </ThankYouFeedback>
      ) : (
        <YesNoThumbs>
          <span>Is this helpful?</span>
          <YesNoThumbs>
            <p onClick={() => HelpulHandler('yes')}>
              <img src="/images/thumbs_up.svg" alt="thumbs_up" />
              <span>Yes</span>
            </p>
            <p onClick={() => HelpulHandler('no')}>
              <img src="/images/thumb_down.svg" alt="thumb_down" />
              <span>No</span>
            </p>
          </YesNoThumbs>
        </YesNoThumbs>
      )}
      {/* <AnyWhereDesktopNotif
                {...props}
                showPopup={showPopup}
                setShowPopup={setShowPopup}
            >
                <GetMyloApp onClick={getAppHandler}>Get Mylo app</GetMyloApp>
            </AnyWhereDesktopNotif> */}
    </HelpFulSection>
  );
}
